import React from 'react'
import styles from './styles.css'
import Paginated from 'meteor-paginated-graphql-react'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import filter from 'lodash/filter'
import Loading from 'orionsoft-parts/lib/components/Loading'
import moment from 'moment'
import MdInfo from 'react-icons/lib/md/info'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import MdCheck from 'react-icons/lib/md/check'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdRemoveCircle from 'react-icons/lib/md/remove-circle'
import MdAccessTime from 'react-icons/lib/md/access-time'
import TagsFilter from '../../../components/fields/TagsFilter'
import MdAssignmentTurnedIn from 'react-icons/lib/md/assignment-turned-in'
import MdAssignment from 'react-icons/lib/md/assignment'
import Actions from 'src/App/components/Actions'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import withOrganization from 'App/Decorators/withOrganization'
import MdUnarchive from 'react-icons/lib/md/unarchive'
import {isMobile} from 'src/App/components/Devices/mediaCheckers'
import MdSend from 'react-icons/lib/md/send'
import SignersStatus from '../Common/SignersStatus'
import FileBinary from 'react-icons/lib/go/file-binary'

@withOrganization
@withRouter
@withMessage
@withMutation(gql`
  mutation archiveDocument($documentId: ID) {
    archiveDocument(documentId: $documentId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation createAlert($documentId: String) {
    createAlert(documentId: $documentId) {
      success
    }
  }
`)
export default class OwnArchivedDocuments extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    archiveDocument: PropTypes.func,
    organization: PropTypes.object,
    createAlert: PropTypes.func,
    showMessage: PropTypes.func
  }

  @autobind
  onSelect({_id}) {
    this.props.router.push(`/documents/${_id}`)
  }

  getFields() {
    if (isMobile()) {
      return [
        {
          title: '',
          name: 'documentStatus{status}',
          render: ({documentStatus}) => this.renderIcon(documentStatus)
        },
        {title: 'Nombre', name: 'name'},
        {
          title: '',
          name: ' ',
          render: item => this.renderActions(item)
        }
      ]
    }
    return [
      {
        title: '',
        name: 'documentStatus{status}',
        render: ({documentStatus}) => this.renderIcon(documentStatus)
      },
      {title: 'Nombre', name: 'name'},
      {
        title: 'Firmas',
        name: 'signersStatus{email, didSign}, feasStatus{email, didSign}, biosStatus{email, didSign}, faceStatus{email, didSign}' ,
        render: ({signersStatus, feasStatus, biosStatus, faceStatus}) =>
          SignersStatus(signersStatus, feasStatus, biosStatus, faceStatus)
      },
      {
        title: 'Fecha',
        name: 'createdAt',
        render: ({createdAt}) => moment(createdAt).format('DD/MM/YYYY HH:mm')
      },
      {
        title: '',
        name: '',
        render: item => this.renderActions(item),
        defaultSort: 'DESC',
        sort: 'DESC'
      }
    ]
  }

  renderActions(item) {
    return (
      <div>
        <span>
          <Actions options={this.renderOptions(item)} />
        </span>
      </div>
    )
  }

  renderOptions(item) {
    let status = item.documentStatus.status
    let typeStatus = {sent: 'sent', feaFlow:'feaFlow'}

    if(typeStatus[status]) return [this.renderArchive(item), this.renderAlert(item)]
    return [this.renderArchive(item)]
  }

  renderArchive(item) {
    return (
      <div onClick={() => this.archiveDocument(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdUnarchive size={20} />
            </div>
            <div className="col-xs-12 col-sm-9">Restaurar documento</div>
          </div>
        </span>
      </div>
    )
  }

  renderAlert(item) {
    return (
      <div onClick={() => this.alert(item)} style={{width: 200}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdSend size={20} style={{color: 'blue'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Recordar firma</div>
          </div>
        </span>
      </div>
    )
  }

  async alert(item) {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.createAlert({documentId: item._id})
      this.props.showMessage('Recordatorio de firma enviado')
    } catch (error) {
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  async archiveDocument(item) {
    try {
      await this.props.archiveDocument(
        {
          documentId: item._id
        },
        {
          refetchQueries: ['documentCount', 'organizationDocCount']
        }
      )
      this.props.showMessage('Documento restaurado')
    } catch (e) {
    } finally {
      this.refs.paginated.reload()
    }
  }

  renderIcon(documentStatus) {
    if (documentStatus.status === 'ready') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'feaFlow') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<FileBinary className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'bioFlow') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAccessTime className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'sent') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAccessTime className={styles.icon2} size={20} />}
          </Tooltip>
        </div>
      )
    } else if (documentStatus.status === 'personal') {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignmentTurnedIn className={styles.icon1} size={20} />}
          </Tooltip>
        </div>
      )
    } else {
      return (
        <div>
          <Tooltip content={this.renderTooltipDocument(documentStatus)}>
            {<MdAssignment className={styles.icon3} size={20} />}
          </Tooltip>
        </div>
      )
    }
  }

  renderTooltipDocument(documentStatus) {
    if (documentStatus.status === 'ready') {
      return <p>Documento firmado</p>
    } else if (documentStatus.status === 'feaFlow') {
      return <p>Esperando firmas electrónicas avanzadas</p>
    } else if (documentStatus.status === 'bioFlow') {
      return <p>Esperando autorizaciones biométricas</p>
    } else if (documentStatus.status === 'sent') {
      return <p>Esperando firmas del documento</p>
    } else if (documentStatus.status === 'personal') {
      return <p>Documento personal</p>
    } else {
      return <p>Documento no enviado para firmar</p>
    }
  }

  renderSignerStatus(signersStatus, documentStatus) {
    const pendingSigns = filter(signersStatus, signerStatus => signerStatus.didSign).length
    if (documentStatus.status === 'personal') {
      return (
        <div>
          <div className="row">
            <div className="col-xs-12 col-sm-3">
              <MdCheckCircle size={17} style={{color: '#3CB371'}} />
            </div>
            <div className="col-xs-12 col-sm-8">Own</div>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Tooltip content={this.renderTooltipContent(signersStatus)}>
              {this.renderTooltip(pendingSigns, signersStatus)}
            </Tooltip>
          </div>
          <div className="col-xs-12 col-sm-8">
            <span>
              {pendingSigns} de {signersStatus.length}
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderTooltip(pendingSigns, signersStatus) {
    if (signersStatus.length === 0) {
      return <MdRemoveCircle size={17} style={{color: '#e4ac00'}} />
    }
    if (pendingSigns === signersStatus.length) {
      return <MdCheckCircle size={17} style={{color: '#3CB371'}} />
    }
    return <MdInfo size={17} />
  }

  renderTooltipContent(signersStatus) {
    if (signersStatus.length === 0) {
      return <p> Documento sin firmantes</p>
    }
    return signersStatus.map((signerStatus, key) => {
      return (
        <p key={key}>
          {signerStatus.didSign && <MdCheck style={{color: 'green', marginRight: 5}} />}
          {signerStatus.email}
        </p>
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              headRightComponent={TagsFilter}
              queryName="archivedDocuments"
              defaultLimit={25}
              fields={this.getFields()}
              ref="paginated"
              params="$filter: String $tags: [String] $organization: String"
              organization={this.props.organization._id}
              onPress={this.onSelect}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/OwnArchivedDocuments/index.js